import './style/topNav.css'
import { useAppDispatch, useAppSelector } from '../app/hooks'
import { logout,  SelectIsLogged,  setLoginModalShow } from '../features/authentication/authenticationSlice'
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { MyCustomTokenPayload } from '../app/consts';

const TopNav = () => {
    const dispatch = useAppDispatch();
    const isLogged = useAppSelector(SelectIsLogged)
    const [localIsLogged, setLocalIsLogged] = useState(false)
    const [showMenu, setShowMenu] = useState(false)
    const [userConnected, setUserConnected] = useState("")

    useEffect(() => {
        setLocalIsLogged(isLogged === undefined || isLogged === false ? false : true)
    }, [isLogged])

    useEffect(() => {
        const token = sessionStorage.getItem('loginToken')
        if (token === null) {
            setUserConnected("אורח")
            return;
        }
        const temp = jwtDecode<MyCustomTokenPayload>(token)
        setUserConnected(temp.name)
        // eslint-disable-next-line
    }, [isLogged])

    return (
        <nav className='navbar' id='navMenu'>
            <button className="hamburger" id="hamburgerBtn" onClick={() => setShowMenu(!showMenu)}>☰</button>
            <ul className={`topnav ${showMenu && "open"}`}>
                <li><Link to={'/'}>מערכת הרשמה לאימונים</Link></li>
                {localIsLogged === true ?
                    <>
                        <li><Link to={'addWorkout'} onClick={() => setShowMenu(false)}>הוסף אימון</Link></li>
                        <li><Link to={'manageWorkout'} onClick={() => setShowMenu(false)}>נהל אימונים</Link></li>
                        <li><Link to={'manageInstructor'} onClick={() => setShowMenu(false)}>נהל מדריכים</Link></li>
                        <li><Link to={'manageWorkoutTypes'} onClick={() => setShowMenu(false)}>נהל סוגי אימונים</Link></li>
                        <li className='push-left'><Link to={'manageUsers'} onClick={() => setShowMenu(false)}>ניהול משתמשים</Link></li>
                        <li><Link to={''} onClick={() => {
                            setShowMenu(false)
                            dispatch(logout("byUser"))
                        }}>שלום {userConnected}, התנתק/י&ensp;</Link></li>
                    </>
                    :
                    <>
                        <li><Link to={'/'}>דף הבית</Link></li>
                        <li className="push-left"><Link to={{}} onClick={() => {
                            setShowMenu(false)
                            dispatch(setLoginModalShow(true))
                        }}>
                            שלום {userConnected}, התחבר/י&ensp;
                        </Link></li>
                    </>}
            </ul>
        </nav>
    )
}

export default TopNav